<div class="onboarding-inner" *transloco="let t; read: 'ONBOARDING_COMPONENT'">
  <ion-icon *ngIf="data.svgPath" [src]="data.svgPath"></ion-icon>
  <img *ngIf="data.imgPath" [src]="data.imgPath" />
  <h2>{{ t(data.key + '.SUBTITLE') }}</h2>
  <div class="mt-8" [innerHTML]="t(data.key + '.DESCRIPTION')"></div>
</div>
